import { setCardStatus, toggleChecklistItem } from "@/lib/projects/card-actions";

export type TickedWork =
  | { type: "card"; id: number; projectId: number; reference: string }
  | { type: "checklist"; id: number; projectId: number; cardId: number; reference: string };

type Outcome = { ok: boolean; error?: string };
type Deps = {
  done: (w: TickedWork) => Promise<Outcome>;
};

const defaults: Deps = {
  done: (w) =>
    w.type === "card"
      ? (setCardStatus({ projectId: w.projectId, cardId: w.id, status: "DONE" }) as Promise<Outcome>)
      : (toggleChecklistItem({ projectId: w.projectId, cardId: w.cardId, itemId: w.id, done: true }) as Promise<Outcome>),
};

/**
 * SPEC §4.2, D61: what the person ticked in the side panel is done once the time is saved.
 * The entry is already saved, so a task that cannot be completed (not assigned to them, needs a deliverable) only produces a message.
 */
export async function completeTicked(items: TickedWork[], deps: Deps = defaults): Promise<string[]> {
  const problems: string[] = [];
  for (const w of items) {
    try {
      const r = await deps.done(w);
      if (!r.ok) problems.push(`${w.reference}: ${r.error ?? "could not be marked done"}`);
    } catch {
      problems.push(`${w.reference}: could not be marked done`);
    }
  }
  return problems;
}
